import { Box, Button, Variants as ButtonVariants } from '@factorialco/deprecated-design-system'
import { F0Button, F0ButtonProps } from '@factorialco/f0-react'

import { useUploadPayrollAction } from './useUploadPayrollAction'
import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'

type TypeBasedOnVersion<V> = V extends 'factorial-one' ? ButtonVariants : F0ButtonProps['variant']

interface Props {
  source: string
  variant?: string
  version?: 'factorial-one' | 'factorial'
  textButton?: string
  type?: TypeBasedOnVersion<Props['version']>
  includeButtonIcon?: boolean
  onFinish?: () => void
  extraButtonProps?: Record<string, unknown>
}

export const UploadPayrollButton = ({
  source,
  textButton,
  extraButtonProps,
  type = 'default',
  includeButtonIcon,
  variant = 'default',
  version = 'factorial-one',
}: Props) => {
  const { insightTableType } = useFinancialWorkspace()
  const factorialOneVersion = version === 'factorial-one'

  const action = useUploadPayrollAction({
    source,
    variant,
    textButton,
    insightTableType,
    includeButtonIcon,
  })

  return (
    <Box data-testid="payroll-summary-import-button">
      {factorialOneVersion && (
        <F0Button
          icon={action.icon}
          label={action.label}
          variant={action.variant}
          onClick={action.onClick}
        />
      )}

      {!factorialOneVersion && (
        <Button
          type={type}
          onClick={action.onClick}
          extra={extraButtonProps}
          iconName={includeButtonIcon ? 'upload' : undefined}
        >
          {action.label}
        </Button>
      )}
    </Box>
  )
}
